import type { ReactNode } from 'react';
import styles from './Sources.module.css';

export interface Source {
  /** The numeric label that matches the superscript marker in the slide body. */
  number: number;
  /** The citation text. */
  text: ReactNode;
  /** Optional URL — rendered as a link at the end of the citation. */
  url?: string;
  /** Optional human-readable URL display. */
  urlLabel?: string;
}

interface SourcesProps {
  sources: Source[];
}

/**
 * Renders the per-slide source block. Sits at the bottom of the slide as a
 * normal flex item — never overlaps content because it pushes content up
 * rather than floating over it.
 */
export default function Sources({ sources }: SourcesProps) {
  if (sources.length === 0) return null;
  return (
    <div className={styles.sources}>
      <span className={styles.heading}>Sources</span>
      <div className={styles.list}>
        {sources.map((s) => (
          <div key={s.number} className={styles.item}>
            <span className={styles.num}>{s.number}.</span>
            <span className={styles.text}>
              {s.text}
              {s.url && (
                <>
                  {' '}
                  <a className={styles.link} href={s.url} target="_blank" rel="noopener noreferrer">
                    {s.urlLabel ?? new URL(s.url).hostname.replace(/^www\./, '')}
                  </a>
                </>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
